import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 4H13.3889C14.1869 4 14.8333 4.59667 14.8333 5.33333V14H15.5556C16.3536 14 17 13.4033 17 12.6667V3.33333C17 2.59667 16.3536 2 15.5556 2H5.44444C4.64639 2 4 2.59667 4 3.33333V4ZM12.6667 5H3.33333C2.59667 5 2 5.63176 2 6.41176V15.5882C2 16.3682 2.59667 17 3.33333 17H12.6667C13.4033 17 14 16.3682 14 15.5882V6.41176C14 5.63176 13.4033 5 12.6667 5ZM11.1111 7H4.88889C4.39778 7 4 7.42118 4 7.94118V14.0588C4 14.5788 4.39778 15 4.88889 15H11.1111C11.6022 15 12 14.5788 12 14.0588V7.94118C12 7.42118 11.6022 7 11.1111 7Z",
		fill: "#0D2976"
	})
});
export default SvgCopy;
